import { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';

/**
 * @method formatFileBytes
 * @param {byte}
 * @usage <formatFileBytes(1000000)>
 *         1000000  =>  Bytes
 * @return {String} =>  1 MB
 */

export function formatFileBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const defaultBytes = 1024;
  const decimalPosition = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const arrayIdx = Math.floor(Math.log(bytes) / Math.log(defaultBytes));

  return `${parseFloat(
    (bytes / defaultBytes ** arrayIdx).toFixed(decimalPosition),
  )} ${sizes[arrayIdx]}`;
}

const useFileUpload = ({
  setFiles,
  isMultiSelect,
  fileType,
  fileSize,
  files,
  setFieldValue,
  setMultiSelectFlag,
  browseFileSeactionFocus,
}) => {
  const [rejectedFiles, setRejectedFiles] = useState([]);
  const [tempValidateFiles, setTempValidateFiles] = useState(false);
  const TotalMaxFileSize = 20 * 1048576;

  const onDrop = useCallback(
    (accFiles, rejFiles) => {
      let currentFileSize = 0;
      const mappedAcc = accFiles.map((file) => {
        currentFileSize = currentFileSize + file.size;
        return { file, errors: [], uploadStatus: 'pending', uploadPercent: 0 };
      });

      if (accFiles.length !== 0) {
        setFieldValue('file', { ...mappedAcc });
      }

      setFiles((curr) => {
        currentFileSize = currentFileSize + calculateFileSize(curr);
        //console.log('----currentFileSize', formatFileBytes(currentFileSize));
        if (currentFileSize < TotalMaxFileSize) {
          setTempValidateFiles(false);
          return [...curr, ...mappedAcc];
        } else {
          setTempValidateFiles(true);
          return [...curr];
        }
      });
      setMultiSelectFlag && setMultiSelectFlag((preState) => !preState);

      const rejAcc = rejFiles.map((file) => {
        const errorMsg = file.errors.map((fileMsg) => {
          if (fileMsg.message.includes('File is larger than')) {
            return `Max supported file size is ${formatFileBytes(fileSize)}`;
          }
          return fileMsg.message;
        });
        return {
          fileName: file.file.name,
          error: errorMsg.join(' and '),
        };
      });
      setRejectedFiles(rejAcc);
      if (browseFileSeactionFocus && browseFileSeactionFocus.current) {
        browseFileSeactionFocus.current.focus();
      }
      browseFileSeactionFocus;
    },
    [setFiles],
  );

  function calculateFileSize(currentFiles) {
    let counter = 0;
    if (currentFiles == undefined || currentFiles.length == 0) {
      return counter;
    } else {
      const result = currentFiles.map((item) => item?.file?.size);
      result.map((item) => {
        counter = counter + item;
      });
      return counter;
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: isMultiSelect,
    accept: {
      fileType,
    },
    maxSize: fileSize,
  });
  return {
    getRootProps,
    getInputProps,
    rejectedFiles,
    tempValidateFiles,
  };
};

export default useFileUpload;
